/* American Premium homepage behaviour (approved homepage.js), bound to the server-rendered Liquid markup:
   motion pause, reveal on scroll, need filter, product carousel, ingredient disclosures, mobile menu, product
   film. The cart drawer is handled by ap-cart.js. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  let paused = reduce.matches;
  try { paused ||= localStorage.getItem('ap-home-motion') === 'paused'; } catch (_) {}
  const motionButton = $('[data-motion]');
  function applyMotion() {
    document.body.classList.toggle('paused', paused);
    if (!motionButton) return;
    motionButton.textContent = paused ? 'Motion paused' : 'Pause motion';
    motionButton.setAttribute('aria-pressed', String(paused));
  }
  applyMotion();
  motionButton?.addEventListener('click', () => { paused = !paused; applyMotion(); try { localStorage.setItem('ap-home-motion', paused ? 'paused' : 'playing'); } catch (_) {} });
  reduce.addEventListener('change', () => { if (reduce.matches) { paused = true; applyMotion(); } });
  const observer = new IntersectionObserver(entries => entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); } }), {threshold: .06});
  document.documentElement.classList.add('js');
  $$('.reveal').forEach(el => observer.observe(el));

  /* Product carousel and need filter */
  const track = $('#product-track');
  const previous = $('[data-prev]');
  const next = $('[data-next]');
  if (track && previous && next) {
    const updateCarousel = () => {
      previous.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    };
    const scrollProducts = sign => {
      const card = track.querySelector('.product-card:not([hidden])');
      if (!card) return;
      track.scrollBy({left: sign * (card.getBoundingClientRect().width + 24), behavior: paused || reduce.matches ? 'instant' : 'smooth'});
    };
    previous.addEventListener('click', () => scrollProducts(-1));
    next.addEventListener('click', () => scrollProducts(1));
    track.addEventListener('scroll', updateCarousel, {passive: true});
    new ResizeObserver(updateCarousel).observe(track);
    track.addEventListener('keydown', e => {
      if (e.target === track && ['ArrowLeft', 'ArrowRight'].includes(e.key)) { e.preventDefault(); scrollProducts(e.key === 'ArrowLeft' ? -1 : 1); }
    });
    const label = $('#selection-label');
    const reset = $('#reset-filter');
    const filterProducts = (button, scroll = true) => {
      const ids = button ? button.dataset.products.split(',').filter(Boolean) : null;
      $$('.need-card').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      $$('.product-card').forEach(c => { c.hidden = Boolean(ids && !ids.includes(c.dataset.product)); });
      label.textContent = ids ? `${button.dataset.needName} · ${ids.length} ${ids.length === 1 ? 'formula' : 'formulas'}` : label.dataset.allLabel;
      reset.hidden = !ids;
      track.scrollLeft = 0;
      updateCarousel();
      if (scroll) {
        $('#shop').scrollIntoView({behavior: paused || reduce.matches ? 'instant' : 'smooth'});
        reset.focus({preventScroll: true});
      }
    };
    $$('[data-need]').forEach(b => b.addEventListener('click', () => filterProducts(b)));
    reset?.addEventListener('click', () => { filterProducts(null, false); track.focus({preventScroll: true}); });
    $$('.hero-actions a[href="#shop"],.mainnav a[href="#shop"],.header-shop[href="#shop"]').forEach(a => a.addEventListener('click', () => filterProducts(null, false)));
    updateCarousel();
  }
  $$('.ingredients').forEach(d => d.addEventListener('toggle', () => { d.querySelector('summary span').textContent = d.open ? 'Hide ingredients' : 'Show ingredients'; }));

  /* Mobile menu */
  const menu = $('.menubtn');
  // The button reads Close while the menu is open and Menu after it closes (labels from the header settings).
  const setMenu = open => {
    if (!menu) return;
    menu.setAttribute('aria-expanded', String(open));
    const label = open ? menu.dataset.labelOpen : menu.dataset.labelClosed;
    if (label) menu.textContent = label;
    $('.mainnav')?.classList.toggle('open', open);
  };
  const closeMenu = () => setMenu(false);
  menu?.addEventListener('click', () => setMenu(menu.getAttribute('aria-expanded') !== 'true'));
  $$('.mainnav a').forEach(a => a.addEventListener('click', closeMenu));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });

  /* Dialogs and the product film (the cart drawer handles its own close) */
  $$('dialog:not(#bag-dialog) [data-close]').forEach(b => b.addEventListener('click', () => b.closest('dialog').close()));
  $$('dialog:not(#bag-dialog)').forEach(d => d.addEventListener('click', e => {
    if (e.target !== d) return;
    const r = d.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
  }));
  const videoDialog = $('#video-dialog');
  const video = videoDialog?.querySelector('video');
  $$('[data-video]').forEach(b => b.addEventListener('click', () => {
    if (!videoDialog) return;
    videoDialog.showModal();
    if (!video.getAttribute('src')) video.src = b.dataset.video;
    video.focus();
    video.play().catch(() => {});
  }));
  videoDialog?.addEventListener('close', () => video.pause());
  video?.addEventListener('error', () => { const f = $('.video-fallback'); if (f) f.hidden = false; });
})();
